import { render } from "./GradeScan.vue?vue&type=template&id=8142a098&scoped=true&ts=true&lang=pug"
import script from "./GradeScan.vue?vue&type=script&lang=ts"
export * from "./GradeScan.vue?vue&type=script&lang=ts"

import "./GradeScan.vue?vue&type=style&index=0&id=8142a098&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8142a098"]])

export default __exports__